import React from "react";

import { FieldSeparator } from "App/styles";

import {
  Container,
  MainSection,
  CardMainText,
  CardSecondaryText,
  Details,
} from "basics/cards";

import ItemCardToolBar from "components/ItemCardToolBar";

import LogoIcon from "icons/entities/LogoIcon";

export default function GalleryCard({
  item,
  selected,
  onSelectEditedItem,
  onSelectDeletedItem,
  onCleanItemId,
}) {
  return (
    <Container selected={selected}>
      <MainSection>
        <LogoIcon />
        <Details>
          <CardMainText>{item.title}</CardMainText>
          <FieldSeparator />
          <CardSecondaryText>
            Posee {item.images.length} imágenes
          </CardSecondaryText>
        </Details>
      </MainSection>

      <ItemCardToolBar
        id={item.id}
        actived={item.actived}
        selected={selected}
        onCleanItemId={onCleanItemId}
        onSelectEditedItem={onSelectEditedItem}
        onSelectDeletedItem={onSelectDeletedItem}
      />
    </Container>
  );
}
